
import { Options, Vue } from "vue-class-component";
import checkRolePermission from "@/app/infrastructures/misc/common-library/CheckRolePermission";
import { SHIPMENT_STT_BOOKING } from "@/app/infrastructures/misc/RolePermission";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { BalanceController } from "@/app/ui/controllers/BalanceController";
import { dataLayer } from "@/app/infrastructures/misc/UtilsGtm";
import { FlagsPermissionBooking } from "@/feature-flags/flag-booking";
import { FlagsPermissionBookingV3 } from "@/feature-flags/flag-booking-v3";
import ModalInstantBoookingConfirmation from "../../views/shipment/booking/component/modal-instant-booking-confirmation.vue";
import { InstantBookingController } from "../../controllers/InstantBookingController";
import Pill from "@/app/ui/components/pill/index.vue";

@Options({
  components: {
    ModalInstantBoookingConfirmation,
    Pill
  }
})
export default class FloatingBooking extends Vue {
  float = true;
  menuFloat = false;
  tncModal = false;
  toggleTooltip() {
    this.menuFloat = !this.menuFloat;
    dataLayer("floating_button_booking_sekarang", {}, [
      "timestamp",
      "userType",
      "userId"
    ]);
  }
  closeFloat() {
    this.float = !this.float;
    dataLayer("floating_button_booking_close", {}, [
      "timestamp",
      "userType",
      "userId"
    ]);
  }
  get menus() {
    const permissions = this.listMenuPermission;

    const result = permissions.filter((item: any) => item.status);
    return {
      data: result,
      title: result[0]?.title,
      action: result[0]?.action,
      total: result.length
    };
  }

  get listMenuPermission() {
    const config = [
      {
        flag: FlagsPermissionBooking.permission_booking_create_manual.isEnabled(),
        title: this.dataProfile.account_type === "client" ? "Booking Klien" : "Booking Retail",
        icon: "booking-retail",
        isNew: false,
        action: this.goToCreate
      },
      {
        flag: FlagsPermissionBookingV3.permission_booking_v3_create_manual.isEnabled(),
        title: "Booking Retail",
        icon: "booking-retail",
        isNew: true,
        action: this.goToCreateV3
      },
      {
        flag:
          FlagsPermissionBooking.permission_booking_create_for_corporate.isEnabled() &&
          !this.dataProfile.isPosChildAccount,
        title: "Booking Klien",
        icon: "booking-client",
        isNew: false,
        action: this.goToCreateClientBook
      },
      {
        flag: FlagsPermissionBookingV3.permission_booking_v3_create_client.isEnabled() &&
          !this.dataProfile.isPosChildAccount,
        title: "Booking Klien",
        icon: "booking-client",
        isNew: true,
        action: this.goToCreateClientV3
      },
      {
        flag: FlagsPermissionBooking.permission_booking_create_shipment_id.isEnabled(),
        title: "Booking Aplikasi & Marketplace",
        icon: "booking-app",
        isNew: false,
        action: this.goToCreateShipmentBook
      },
      {
        flag: FlagsPermissionBookingV3.permission_booking_v3_create_markeplace.isEnabled(),
        title: "Booking Aplikasi & Marketplace",
        icon: "booking-app",
        isNew: true,
        action: this.goToCreateShipmentBookV3
      },
      {
        flag: FlagsPermissionBooking.permission_instant_booking_create.isEnabled(),
        title: "Booking Instan",
        icon: "booking-instant",
        isNew: false,
        action: this.openTncModal
      }
    ];

    return config.map(item => this.createMenuItem(item));
  }

  private createMenuItem({
    flag,
    title,
    icon,
    isNew,
    action
  }: {
    flag: boolean;
    title: string;
    icon: string;
    isNew: boolean;
    action: Function | Record<string, never>;
  }) {
    return {
      status: flag,
      title,
      icon,
      isNew,
      action: this.validationAccount ? action : {}
    };
  }

  get dataProfile() {
    return AccountController.accountData;
  }

  balanceUnderLimit = false;
  get isBalanceUnderLimitForPos() {
    return (
      BalanceController.balanceData.walletBalance <
        this.dataProfile.limit_rule_min_balance &&
      this.dataProfile.account_type === "partner"
    );
  }
  async goToCreate() {
    this.menuFloat = false;
    if (this.isBalanceUnderLimitForPos) {
      this.balanceUnderLimit = true;
      return;
    }
    await this.$router.push("/booking/create");
    this.$router.push("/booking/create");
    dataLayer("floating_button_booking_manual", {}, [
      "timestamp",
      "userType",
      "userId"
    ]);
  }
  
  goToCreateV3() {
    this.menuFloat = false;
    this.$router.push("/booking-v2/create-v3");
    dataLayer("floating_button_booking_manual", {}, [
      "timestamp",
      "userType",
      "userId"
    ]);
  }

  goToCreateClientV3() {
    this.menuFloat = false;
    this.$router.push("/booking-v2/create-client-v3");
    dataLayer("floating_button_booking_client", {}, [
      "timestamp",
      "userType",
      "userId"
    ]);
  }

  goToCreateClientBook() {
    this.menuFloat = false;
    this.$router.push("/booking/create-client");
    dataLayer("floating_button_booking_client", {}, [
      "timestamp",
      "userType",
      "userId"
    ]);
  }

  goToCreateShipmentBook() {
    this.menuFloat = false;
    this.$router.push(`/booking/create/by-shipment-id`);
    dataLayer("floating_button_booking_shipment", {}, [
      "timestamp",
      "userType",
      "userId"
    ]);
  }

  goToCreateShipmentBookV3() {
    this.menuFloat = false;
    this.$router.push(`/booking-v2/create/by-shipment-id`);
    dataLayer("floating_button_booking_shipment", {}, [
      "timestamp",
      "userType",
      "userId"
    ]);
  }

  goToInstantBooking() {
    this.menuFloat = false;
    this.tncModal = false;
    InstantBookingController.setIsInstantBookingTncConfirmed(true);
    this.$router.push("/booking/create/instant-booking-shipment");
    dataLayer("floating_button_booking_instant", {}, [
      "timestamp",
      "userType",
      "userId"
    ]);
  }

  onCloseAnywhere(value: boolean) {
    this.menuFloat = value;
  }

  get validationAccount() {
    return AccountController.validationAccount;
  }

  openTncModal() {
    this.tncModal = true;
  }

  onCloseTncModal() {
    this.tncModal = false;
  }
}
